import React, {useEffect, useState} from 'react';
import "../../assets/scss/components/form/section.scss";
import { ArrowDownBold } from "../../assets/icons/Icons";

const FormSection = ({ children, collapsible, collapsed, errorPosition, errors, ...props }) => {
    const [isCollapsed, setIsCollapsed] = useState(false);

    useEffect(() => {
        setIsCollapsed(collapsed);
    }, [collapsed]);

    const handleToggle = () => {
        if (collapsible) {
            setIsCollapsed(!isCollapsed);
        }
    };

    return (
        <div className={`form-section ${collapsible ? 'collapsible' : ''} ${props.className}`}>
            {props.title && <div className="form-section__title" onClick={handleToggle}>
                {props.beforeTitle}
                {props.title}
                {props.required ? ' *' : ''}
                {collapsible && (
                    <span className="form-section__arrow"
                          style={{transform: isCollapsed ? 'rotate(180deg)' : 'rotate(0deg)'}}>
                        <ArrowDownBold/>
                    </span>
                )}
            </div> }
            <div className={`form-section__content ${isCollapsed ? 'collapsed' : ''}`}>
                {children}
            </div>
            {Array.isArray(errors) &&
                <div className={'form-section__error'}>
                    {errors
                        .filter(({position}) => position?.includes(errorPosition))
                        .map(({message}, index) => (
                            <p key={index}>{message}</p>
                        ))}
                </div>
            }

        </div>
    );
};

export default FormSection;